const suggestionsList = [
  "Aldersgate",
  "Cripplegate",
  "Portsoken",
  "Walbrook",
  "Farringdon Without",
  "Northbury",
  "Parsloes",
  "Alibon",
  "Becontree",
  "Mayesbrook",
  "Chadwell Heath",
  "Eastbrook & Rush Green",
  "Eastbury",
  "Gascoigne",
  "Abbey",
  "Goresbrook",
  "Heath",
  "Valence",
  "Longbridge",
  "Beam",
  "Barking Riverside",
  "Thames View",
  "Whalebone",
  "Village",
  "Brunswick Park",
  "Colindale North",
  "Burnt Oak",
  "Childs Hill",
  "Cricklewood",
  "West Hendon",
  "Friern Barnet",
  "East Barnet",
  "East Finchley",
  "Edgwarebury",
  "Edgware",
  "Finchley Church End",
  "Garden Suburb",
  "Golders Green",
  "Hendon",
  "Barnet Vale",
  "High Barnet",
  "Mill Hill",
  "Totteridge & Woodside",
  "Whetstone",
  "Underhill",
  "West Finchley",
  "Woodhouse",
  "Barnehurst",
  "Bexleyheath",
  "Crayford",
  "Belvedere",
  "Blackfen & Lamorbey",
  "Blendon & Penhill",
  "Crook Log",
  "West Heath",
  "Erith",
  "Northumberland Heath",
  "Sidcup",
  "St Mary's & St James",
  "Falconwood & Welling",
  "East Wickham",
  "Thamesmead East",
  "Longlands",
  "Slade Green & Northend",
  "Alperton",
  "Wembley Central",
  "Welsh Harp",
  "Barnhill",
  "Kenton",
  "Brondesbury Park",
  "Dollis Hill",
  "Willesden Green",
  "Roundwood",
  "Kingsbury",
  "Queensbury",
  "Harlesden & Kensal Green",
  "Queens Park",
  "Kilburn",
  "Cricklewood & Mapesbury",
  "Northwick Park",
  "Wembley Hill",
  "Preston",
  "Stonebridge",
  "Sudbury",
  "Tokyngton",
  "Bickley & Sundridge",
  "Biggin Hill",
  "Bromley Common & Holwood",
  "Hayes & Coney Hall",
  "Bromley Town",
  "Shortlands & Park Langley",
  "Chelsfield",
  "Farnborough & Crofton",
  "Chislehurst",
  "Clock House",
  "Beckenham Town & Copers Cope",
  "St Paul's Cray",
  "St Mary Cray",
  "Crystal Palace & Anerley",
  "Penge & Cator",
  "Darwin",
  "Kelsey & Eden Park",
  "Mottingham",
  "Orpington",
  "Petts Wood & Knoll",
  "Plaistow",
  "West Wickham",
  "Belsize",
  "Primrose Hill",
  "Bloomsbury",
  "Camden Town",
  "St Pancras & Somers Town",
  "Kentish Town South",
  "Camden Square",
  "Fortune Green",
  "Frognal",
  "Gospel Oak",
  "Hampstead Town",
  "Haverstock",
  "Highgate",
  "Holborn & Covent Garden",
  "Kentish Town North",
  "South Hampstead",
  "Regent's Park",
  "King's Cross",
  "West Hampstead",
  "Addiscombe West",
  "Addiscombe East",
  "Shirley North",
  "Bensham Manor",
  "Broad Green",
  "Old Coulsdon",
  "Coulsdon Town",
  "Purley & Woodcote",
  "Sanderstead",
  "South Croydon",
  "Purley Oaks & Riddlesdown",
  "Fairfield",
  "Park Hill & Whitgift",
  "New Addington North",
  "Selsdon Vale & Forestdale",
  "Selsdon & Addington Village",
  "Shirley South",
  "Kenley",
  "New Addington South",
  "Norbury Park",
  "Norbury & Pollards Hill",
  "Selhurst",
  "South Norwood",
  "Crystal Palace & Upper Norwood",
  "Thornton Heath",
  "Waddon",
  "West Thornton",
  "Woodside",
  "North Acton",
  "East Acton",
  "South Acton",
  "Pitshanger",
  "Dormers Wells",
  "Ealing Broadway",
  "Ealing Common",
  "Southfield",
  "Hanwell Broadway",
  "Greenford Broadway",
  "Central Greenford",
  "Hanger Hill",
  "North Hanwell",
  "Lady Margaret",
  "Northfield",
  "North Greenford",
  "Northolt Mandeville",
  "Northolt West End",
  "Southall Green",
  "Norwood Green",
  "Southall Broadway",
  "Perivale",
  "Southall West",
  "Walpole",
  "New Southgate",
  "Bowes",
  "Bush Hill Park",
  "Southbury",
  "Highfield",
  "Whitewebbs",
  "Cockfosters",
  "Oakwood",
  "Edmonton Green",
  "Brimsdown",
  "Carterhatch",
  "Enfield Lock",
  "Town",
  "Grange Park",
  "Ridgeway",
  "Haselbury",
  "Jubilee",
  "Lower Edmonton",
  "Palmers Green",
  "Ponders End",
  "Southgate",
  "Arnos Grove",
  "Bullsmoor",
  "Upper Edmonton",
  "Winchmore Hill",
  "Abbey Wood",
  "Blackheath Westcombe",
  "Charlton Village & Riverside",
  "Charlton Hornfair",
  "Mottingham, Coldharbour & New Eltham",
  "Eltham Park & Progress",
  "Eltham Town & Avery Hill",
  "Eltham Page",
  "Woolwich Arsenal",
  "Plumstead & Glyndon",
  "Woolwich Common",
  "Greenwich Park",
  "Greenwich Creekside",
  "Kidbrooke Park",
  "Middle Park & Horn Park",
  "Kidbrooke Village & Sutcliffe",
  "East Greenwich",
  "Plumstead Common",
  "Shooters Hill",
  "West Thamesmead",
  "Thamesmead Moorings",
  "Woolwich Dockyard",
  "Greenwich Peninsula",
  "Woodberry Down",
  "Brownswood",
  "Cazenove",
  "Homerton",
  "King's Park",
  "Clissold",
  "Stoke Newington",
  "Shacklewell",
  "Dalston",
  "De Beauvoir",
  "Hoxton East & Shoreditch",
  "Hackney Central",
  "Hackney Downs",
  "Haggerston",
  "Hoxton West",
  "Lea Bridge",
  "Stamford Hill West",
  "Springfield",
  "London Fields",
  "Victoria",
  "Hackney Wick",
  "Brook Green",
  "Addison",
  "Coningham",
  "Wendell Park",
  "Avonmore",
  "College Park & Old Oak",
  "Munster",
  "Walham Green",
  "Lillie",
  "Fulham Reach",
  "Hammersmith Broadway",
  "Grove",
  "West Kensington",
  "Palace & Hurlingham",
  "Parsons Green & Sandford",
  "Ravenscourt",
  "Sands End",
  "Shepherd's Bush Green",
  "White City",
  "Fulham Town",
  "Wormholt",
  "Alexandra Park",
  "Fortis Green",
  "Bounds Green",
  "Bruce Castle",
  "Tottenham Central",
  "Crouch End",
  "Muswell Hill",
  "Harringay",
  "Hornsey",
  "Noel Park",
  "Northumberland Park",
  "St Ann's",
  "Hermitage & Gardens",
  "South Tottenham",
  "Seven Sisters",
  "Stroud Green",
  "Tottenham Hale",
  "West Green",
  "White Hart Lane",
  "Belmont",
  "Centenary",
  "Stanmore",
  "Canons",
  "Greenhill",
  "Marlborough",
  "Harrow on the Hill",
  "West Harrow",
  "Harrow Weald",
  "Hatch End",
  "North Harrow",
  "Pinner",
  "Headstone",
  "Pinner South",
  "Kenton East",
  "Kenton West",
  "Wealdstone South",
  "Rayners Lane",
  "Roxbourne",
  "Roxeth",
  "Wealdstone North",
  "St Edward's",
  "Rush Green & Crowlands",
  "Cranham",
  "Elm Park",
  "Harold Wood",
  "Emerson Park",
  "Squirrels Heath",
  "Gooshays",
  "Heaton",
  "Hacton",
  "St Andrew's",
  "Havering-atte-Bower",
  "Hylands & Harrow Lodge",
  "Mawneys",
  "Marshalls & Rise Park",
  "Rainham & Wennington",
  "St Alban's",
  "Beam Park",
  "South Hornchurch",
  "Upminster",
  "Yeading",
  "Belmore",
  "Wood End",
  "Colham & Cowley",
  "South Ruislip",
  "Eastcote",
  "Charville",
  "Ruislip",
  "Harefield Village",
  "Ickenham & South Harefield",
  "Heathrow Villages",
  "Hillingdon East",
  "Ruislip Manor",
  "Northwood",
  "Northwood Hills",
  "Pinkwell",
  "Hayes Town",
  "Hillingdon West",
  "Uxbridge",
  "West Drayton",
  "Yiewsley",
  "Bedfont",
  "Brentford West",
  "Chiswick Homefields",
  "Chiswick Riverside",
  "Cranford",
  "Feltham North",
  "Feltham West",
  "Hanworth Village",
  "Hanworth Park",
  "Heston Central",
  "Heston East",
  "Heston West",
  "Hounslow East",
  "Hounslow Central",
  "Hounslow Heath",
  "Hounslow South",
  "Hounslow West",
  "Isleworth",
  "Osterley & Spring Grove",
  "Syon & Brentford Lock",
  "Chiswick Gunnersbury",
  "Barnsbury",
  "Caledonian",
  "Bunhill",
  "St Peter's & Canalside",
  "Laycock",
  "Canonbury",
  "Clerkenwell",
  "Finsbury Park",
  "Tollington",
  "Highbury",
  "Arsenal",
  "Hillrise",
  "Holloway",
  "Junction",
  "Mildmay",
  "Tufnell Park",
  "St Mary's & St James'",
  "Abingdon",
  "Holland",
  "Brompton & Hans Town",
  "Stanley",
  "Campden",
  "Colville",
  "Earl's Court",
  "Courtfield",
  "Redcliffe",
  "Chelsea Riverside",
  "Golborne",
  "Royal Hospital",
  "Notting Dale",
  "Norland",
  "St. Helen's",
  "Pembridge",
  "Queen's Gate",
  "Dalgarno",
  "King George's & Sunray",
  "Alexandra",
  "Surbiton Hill",
  "Berrylands",
  "Green Lane & St James",
  "New Malden Village",
  "Kingston Gate",
  "Canbury Gardens",
  "Hook & Chessington North",
  "Chessington South & Malden Rushett",
  "Coombe Hill",
  "Coombe Vale",
  "Kingston Town",
  "St Mark's & Seething Wells",
  "Norbiton",
  "Old Malden",
  "Motspur Park & Old Malden East",
  "Tolworth",
  "Tudor",
  "Waterloo & South Bank",
  "Kennington",
  "Brixton Acre Lane",
  "Clapham Park",
  "Brixton Rush Common",
  "Clapham Common & Abbeville",
  "Clapham East",
  "Clapham Town",
  "Brixton Windrush",
  "Brixton North",
  "Gipsy Hill",
  "West Dulwich",
  "Herne Hill & Loughborough Junction",
  "Knight's Hill",
  "Stockwell West & Larkhall",
  "Stockwell East",
  "Oval",
  "Vauxhall",
  "Streatham St Leonard's",
  "Streatham Hill East",
  "Streatham Hill West & Thornton",
  "St Martin's",
  "Streatham Common & Vale",
  "Streatham Wells",
  "Myatt's Fields",
  "Bellingham",
  "Perry Vale",
  "Rushey Green",
  "Blackheath",
  "Brockley",
  "Catford South",
  "Hither Green",
  "Crofton Park",
  "Downham",
  "Evelyn",
  "New Cross Gate",
  "Deptford",
  "Forest Hill",
  "Grove Park",
  "Ladywell",
  "Lee Green",
  "Sydenham",
  "Telegraph Hill",
  "Wandle",
  "Cannon Hill",
  "Colliers Wood",
  "Cricket Green",
  "Lavender Fields",
  "Raynes Park",
  "Wimbledon Town & Dundonald",
  "Figge's Marsh",
  "Graveney",
  "Hillside",
  "Longthornton",
  "Lower Morden",
  "Merton Park",
  "Pollards Hill",
  "Ravensbury",
  "St Helier",
  "West Barnes",
  "Wimbledon Park",
  "Beckton",
  "Boleyn",
  "Plaistow North",
  "Canning Town North",
  "Plaistow West & Canning Town East",
  "Custom House",
  "Plaistow South",
  "East Ham",
  "Little Ilford",
  "Plashet",
  "East Ham South",
  "Forest Gate North",
  "Maryland",
  "Forest Gate South",
  "Green Street East",
  "Green Street West",
  "Manor Park",
  "Stratford",
  "Wall End",
  "West Ham",
  "Canning Town South",
  "Aldborough",
  "Barkingside",
  "Bridge",
  "South Woodford",
  "Churchfields",
  "Clayhall",
  "Cranbrook",
  "Fairlop",
  "Fullwell",
  "Goodmayes",
  "Hainault",
  "Loxford",
  "Clementswood",
  "Mayfield",
  "Monkhams",
  "Newbury",
  "Valentines",
  "Seven Kings",
  "Wanstead Village",
  "Ilford Town",
  "Wanstead Park",
  "Barnes",
  "East Sheen",
  "Fulwell & Hampton Hill",
  "Ham, Petersham & Richmond Riverside",
  "Hampton",
  "Hampton North",
  "Hampton Wick & South Teddington",
  "Heathfield",
  "Kew",
  "Mortlake & Barnes Common",
  "North Richmond",
  "St Margarets & North Twickenham",
  "South Richmond",
  "South Twickenham",
  "Teddington",
  "Twickenham Riverside",
  "West Twickenham",
  "Whitton",
  "St Giles",
  "Camberwell Green",
  "Newington",
  "Borough & Bankside",
  "St George's",
  "Chaucer",
  "Dulwich Wood",
  "Dulwich Hill",
  "Goose Green",
  "North Walworth",
  "Faraday",
  "South Bermondsey",
  "London Bridge & West Bermondsey",
  "Old Kent Road",
  "Nunhead & Queen's Road",
  "Rotherhithe",
  "Peckham Rye",
  "Peckham",
  "North Bermondsey",
  "Champion Hill",
  "Rye Lane",
  "Surrey Docks",
  "Dulwich Village",
  "Beddington",
  "South Beddington & Roundshaw",
  "Carshalton Central",
  "Carshalton South & Clockhouse",
  "Cheam",
  "Worcester Park South",
  "North Cheam",
  "St Helier West",
  "Stonecot",
  "Sutton Central",
  "Sutton West & East Cheam",
  "Sutton North",
  "Sutton South",
  "The Wrythe",
  "Wallington North",
  "Wallington South",
  "St Helier East",
  "Hackbridge",
  "Worcester Park North",
  "Bethnal Green West",
  "Bethnal Green East",
  "Spitalfields & Banglatown",
  "Blackwall & Cubitt Town",
  "Island Gardens",
  "Bow East",
  "Bow West",
  "Bromley North",
  "Bromley South",
  "Lansbury",
  "Mile End",
  "Limehouse",
  "Poplar",
  "St Dunstan's",
  "Canary Wharf",
  "Stepney Green",
  "St Katharine's & Wapping",
  "Whitechapel",
  "Shadwell",
  "Weavers",
  "Cann Hall",
  "Cathall",
  "Chapel End",
  "Hale End & Highams Park South",
  "Chingford Green",
  "Endlebury",
  "Valley",
  "Forest",
  "Grove Green",
  "Upper Walthamstow",
  "Hatch Lane & Highams Park North",
  "St James",
  "High Street",
  "Higham Hill",
  "Hoe Street",
  "Larkswood",
  "Leyton",
  "Leytonstone",
  "Markhouse",
  "William Morris",
  "Wood Street",
  "Balham",
  "Northcote",
  "Tooting Bec",
  "South Balham",
  "Wandsworth Common",
  "East Putney",
  "West Putney",
  "Wandsworth Town",
  "Furzedown",
  "Tooting Broadway",
  "Falconbrook",
  "Battersea Park",
  "Trinity",
  "Lavender",
  "Shaftesbury & Queenstown",
  "Roehampton",
  "St Mary's",
  "Southfields",
  "Thamesfield",
  "West Hill",
  "Abbey Road",
  "Bayswater",
  "Marylebone",
  "Pimlico South",
  "Church Street",
  "Harrow Road",
  "Maida Vale",
  "Hyde Park",
  "Lancaster Gate",
  "Knightsbridge & Belgravia",
  "Little Venice",
  "West End",
  "Queen's Park",
  "St James's",
  "Pimlico North",
  "Vincent Square",
  "Westbourne"
];

export default suggestionsList;